import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { DateUniversal } from '../classes/date-universal.class';
import { UniversalStorageService } from './universal-storage.service';

@Injectable({
    providedIn: 'root',
})
export class BtlTranslateServices implements TranslateLoader {
    private translation: Observable<any>;

    constructor(
        private http: HttpClient,
        private universalStorage: UniversalStorageService,
        private translateService: TranslateService,
    ) {
        const translation: any = this.universalStorage.getItem('translation');
        if (translation) {
            this.translation = of(translation);
        }
    }

    public getTranslation(): Observable<any> {
        if (!this.translation) {
            const apiAddress = 'https://www.bouyguestelecom.fr/i18n/magento.json';

            const headers = new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('Access-Control-Allow-Origin', '*');

            const httpOptions = {
                headers,
            };

            return this.http.get(apiAddress, httpOptions).pipe(
                map((result: object) => result),
                tap((translation) => {
                    this.universalStorage.setItem(
                        'translation',
                        translation,
                        new DateUniversal('now').addDay(1).getTime(),
                        false,
                    );
                }),
            );
        }
        return this.translation;
    }

    get(key: string, interpolateParams?: object): Observable<string> {
        return this.translateService.get(key, interpolateParams);
    }
}
